module.exports = __webpack_public_path__ + "img/worm.f4a13d56.png";